import { Box } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import CustomRadioGroup from "@/components/RHFcomponents/CustomRadioGroup";
import {useGetShippingQuery} from "@/redux-store/api/marketingApi.ts";

interface IProp {
    methods: UseFormReturn<ICheckoutForm, unknown, undefined>;
}

const FormSecondStep: React.FC<IProp> = ({ methods: { control } }) => {
    const { data } = useGetShippingQuery({});
    return (
    <Box display="flex" gap={{ xs: 2, md: 3 }} flexDirection="column">
      <CustomRadioGroup
        name="shippingMethod"
        control={control}
        options={data as any}
      />
    </Box>
  );
};

export default FormSecondStep;
